<template>
    <layout>        

        <template v-slot:username>
            <v-form 
                class="pa-5"
                @submit.prevent
            >
                <v-text-field
                    label="Username"
                    placeholder="Enter username"
                    name="id"                                                
                    type="text"
                    color="primary"
                    v-model="formData.name"
                    clearable
                    autofocus
                    v-on:keyup="keyPress"
                    auto-complete="off"
                >
                    <v-icon
                        slot="prepend"
                        color="primary"
                    >
                        mdi-account
                    </v-icon>
                </v-text-field>
                <div class="text-right mt-4 mb-4">                                                
                    <v-btn 
                        color="primary"
                        @click="nextStep" 
                        dark
                        block
                    >NEXT</v-btn>
                </div>
            </v-form>
        </template>

        <template v-slot:password>
            <v-form 
                class="pa-5"
                @submit.prevent="submit"
            >
                <v-text-field
                    v-show="password"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show ? 'text' : 'password'"
                    :label="passwordLabel"
                    :placeholder="passwordPlaceholder"
                    :hint="passwordHint"
                    persistent-hint
                    @click:append="show = !show"                                                    
                    name="password"
                    v-model="formData.password"
                    clearable
                    autofocus
                    color="primary"
                >
                    <v-icon
                        slot="prepend"
                        color="primary"
                    >
                        mdi-key
                    </v-icon>
                </v-text-field>
            

                <div class="text-right mt-4  mb-4">
                    <v-btn 
                        color="primary"
                        @click="submit" 
                        dark
                        block
                     >
                        LOGIN
                     </v-btn>
                </div>
            </v-form>             
        </template>

    </layout>
</template>

<script>
import Layout from '../layouts/Login';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import axios from 'axios';

export default {
    name: 'LoginTermReports',
    components: {
        Layout
    },
    data: () => ({
        formData: {
            name: '',
            password: '',            
        },
        show: false,        
        passwordPlaceholder: 'Enter password',
        passwordLabel: 'Password',
        passwordHint: '',
        password: true,
    }),

    computed: {
        ...mapGetters({            
            step: 'auth/getStep',
            authenticated: 'auth/getAuthenticated',
            resetPassword: 'auth/getResetPassword',
            employeeInitials: 'auth/getEmployeeInitials',
            employeeSignedIn: 'auth/getEmployeeSignedIn', 
        }),        
    },

    methods: {
        ...mapActions({
            signIn: 'auth/signIn', 
            getUser: 'auth/user',
            getUserPermissionList: 'app/getUserPermissionList',
            setAuthenticated: 'auth/setAuthenticated',
            userPermissions: 'auth/userPermissions',
            serverError: 'auth/serverError',   
                  
        }),

        ...mapMutations({
            setLoginError: 'auth/setLoginErrors', 
            setStep: 'auth/setStep',
            setOverlay: 'auth/setOverlay',
            setUserName: 'auth/setUserName',
            setResetPassword: 'auth/setResetPassword',
            setPermissions: 'auth/setPermissions',
            setEmployeeId: 'auth/setEmployeeId',
            setCredentials: 'auth/setCredentials',
            setAuthenticated: 'auth/setAuthenticated',
            setEmployeeSignedIn: 'auth/setEmployeeSignedIn',
            setEmployeeInitials: 'auth/setEmployeeInitials' ,
            setUser: 'auth/setUser',
            setAuthToken: 'auth/setAuthToken',          
        }),

        async nextStep () {
            this.setUserName(this.formData.name);
            this.setStep(2); 

            // this.setOverlay(true);
            // this.setUserName(this.formData.name);
            // if(this.formData.name === 'Admin'){
            //     sessionStorage.setItem('employeeSignedIn', 'Admin');
            //     sessionStorage.setItem('employeeInitials', 'A')                
            //     this.setEmployeeSignedIn('Admin');
            //     this.setEmployeeInitials('A');
            //     this.setOverlay(false);
            //     this.loginError('');
            //     this.setStep(2);
            //     return;
            // }

            // try {
            //     const { data: { employee, user }} = await this.getUser(); 
            //     // console.log('data: ', data); 
            //     this.setEmployeeId(employee.id);
            //     sessionStorage.setItem('employeeSignedIn', employee.first_name + ' ' + employee.last_name);
            //     sessionStorage.setItem('employeeInitials', employee.first_name[0] + employee.last_name[0])  
                       
            //     this.setEmployeeSignedIn(employee.first_name + ' ' + employee.last_name);
            //     this.setEmployeeInitials(employee.first_name[0] + employee.last_name[0]);

            //     this.setOverlay(false);
            //     this.loginError('');

            //     if(user.password_reset == 1){
            //         this.setResetPassword(true);
            //     }
            //     else{
            //         this.setResetPassword(false);                    
            //     }
            //     this.setStep(2); 

            // } catch (error) {
            //     this.setOverlay(false);
            //     error.response ? console.log(error.response) : console.log(error);

            //     if(error.response){
            //         this.loginError(error.response.data.message);
            //     }
            //     else{
            //         this.loginError(`An Error has occured ( ${error})`)
            //     }
                
            // }
            
            
        },

        async submit () {  
            this.setLoginError('');          
            this.setOverlay(true);
            this.setCredentials(this.formData);
            try {
                const { data } = await this.signIn();
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.auth_token;
               
                sessionStorage.setItem('auth_token', data.auth_token);
                sessionStorage.setItem("authenticated", "true");
                sessionStorage.setItem("employeeId", data.employee_id ?? data.name);
               
                this.setAuthToken(data.auth_token);

                const user = {
                    employee_id: data.employee_id ?? data.name,
                }

                this.setUser(JSON.stringify(user));
                sessionStorage.setItem("user", JSON.stringify(user));
                console.log('Authenticated.') 
                
                this.setAuthenticated(true);               
                this.setLoginError(''); 
                
                if(data.name === 'Admin'){
                    sessionStorage.setItem('employeeSignedIn', 'Admin');
                    sessionStorage.setItem('employeeInitials', 'A')                
                    this.setEmployeeSignedIn('Admin');
                    this.setEmployeeInitials('A');
                }
                
                if(data.name !== 'Admin'){
                    
                    sessionStorage.setItem('employeeSignedIn', data.first_name + ' ' + data.last_name);
                    sessionStorage.setItem('employeeInitials', data.first_name[0] + data.last_name[0])  
                    sessionStorage.setItem('employeeId', data.employee_id);
                    
                    this.setEmployeeId(data.employee_id);
                    this.setEmployeeSignedIn(data.first_name + ' ' + data.last_name);
                    this.setEmployeeInitials(data.first_name[0] + data.last_name[0]);
                    
                    const { data: dataPermissions } = await this.userPermissions();
                    
                    sessionStorage.setItem('permissions', JSON.stringify(dataPermissions));
                    
                }
                
                if(data.name !== 'Admin' && data.password_reset == 1){
                    console.log('Password reset required.');
                    this.setStep(3);
                    this.setOverlay(false);
                    return;
                }

                console.log('Redirecting...');
                this.$router.replace('/app');

            } catch (error) {
                this.setOverlay(false);
                // console.log(error.response);
                this.serverError(error);
                
            }
            this.setOverlay(false);
        },
        
        keyPress (e) {
            if(e.keyCode === 13){
                this.nextStep();
            }
        },
        
    },
}
</script>